import "#packages/ecma402-abstract/types/date-time.js";
import { PartitionDateTimePattern } from "#packages/ecma402-abstract/DateTimeFormat/PartitionDateTimePattern.js";
/**
* https://tc39.es/ecma402/#sec-formatdatetime
* @param dtf DateTimeFormat
* @param x
*/
export function FormatDateTime(dtf, x, implDetails) {
	const parts = PartitionDateTimePattern(dtf, x, implDetails);
	let result = "";
	for (const part of parts) {
		result += part.value;
	}
	return result;
}
